import React, { useEffect, useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import VideoBlockContainer from "./videoBlockContainer";
import { getParticipantBlockStatus, isTrackStreamingStatusActive, setGalleryParticipiants, setGalleryTracks } from "../../../utils/functions";

// let interval = 0;
// let intervalTime = 30 * 1000;

function GalleryView({ showActiveWindow }) {
  const localUser = useSelector((state) => state.conf.localUser);
  const roomDetail = useSelector((state) => state.conf.roomDetail);
  const dominantSpeaker = useSelector((state) => state.conf.dominantSpeaker);
  const screenDimension = useSelector((state) => state.conf.screenDimension);
  const galleryViewParticipants = useSelector((state) => state.conf.galleryViewParticipants);

  const currrentPage = useSelector((state) => state.conf.currrentPage);
  const maxVideos = useSelector((state) => state.conf.maxVideos);
  const activeVideoParticipantIds = useSelector((state) => state.conf.activeVideoParticipantIds);
  const currentActiveVideoTracks = useSelector((state) => state.conf.currentActiveVideoTracks);
  const participantIds = useSelector((state) => state.conf.participantIds);
  const screenSharedJid = useSelector((state) => state.conf.screenSharedJid);
  const unmutedParticipantIds = useSelector((state) => state.conf.unmutedParticipantIds);
  const videoContainerSettings = useSelector((state) => state.conf.videoContainerSettings);
  const trackStreamStatus = useSelector((state) => state.conf.trackStreamStatus);

  const refreshVideoView = useSelector((state) => state.conf.refreshVideoView);
  const extensionDetails = useSelector((state) => state.conf.extensionDetails);
  const tracksfirstUpdate = useRef(true);

  const { height, width } = screenDimension;

  useEffect(() => {
    if (!showActiveWindow) {
      setGalleryParticipiants();
    }
  }, [
    maxVideos,
    currrentPage,
    showActiveWindow,
    videoContainerSettings?.hide_muted_attendees,
    unmutedParticipantIds,
    activeVideoParticipantIds,
    localUser,
    screenSharedJid,
    // dominantSpeaker,
    refreshVideoView,
  ]);

  useEffect(() => {
    if (!showActiveWindow) {
      let checkOnGallery = galleryViewParticipants.filter((filterItem) => filterItem.jid !== localUser?.jid).some((item) => !participantIds.includes(item.jid));

      if (checkOnGallery) {
        setGalleryParticipiants();
      } else if (galleryViewParticipants.length < maxVideos) {
        setGalleryParticipiants();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [participantIds]);

  useEffect(() => {
    if (tracksfirstUpdate.current) {
      tracksfirstUpdate.current = false;
      return;
    }

    setGalleryTracks(currentActiveVideoTracks, true);
  }, [currentActiveVideoTracks]);

  const _participantsList = useMemo(() => {
    return galleryViewParticipants.filter((u) => u);
  }, [galleryViewParticipants]);

  console.log('extensionDetails', extensionDetails?.backgroundColor);

  return (
    <>
      {_participantsList.length > 0 ? (
        _participantsList.map((participant) => {
          let speakerClass = participant?.jid === dominantSpeaker && _participantsList.length > 1 ? "highlighted-box" : "";
          let isBlocked = getParticipantBlockStatus(participant);
          let darkBackground = participant?.track && !isBlocked ? "" : "darkGrey";
          let isActive = isTrackStreamingStatusActive(participant?.track, trackStreamStatus);
          let isAttendeeRecorder = participant?.isAttendeeRecorder;

          // let statusInactive = !isActive && showWarning;
          // let isVideoInactive = (participant?.track && audioMode) || statusInactive ? true : false;

          let isVideoInactive = !isActive;

          return (
            <div className={`videoBlock ${speakerClass} ${darkBackground}`}
              style={{
                width: `${width}px`,
                height: `${height}px`,
                background: isAttendeeRecorder && extensionDetails?.backgroundColor  ,
                color: isAttendeeRecorder && extensionDetails?.textColor,
                '--dynamic-shadow': `inset 0 0 0 .2em ${roomDetail?.active_speaker_highlight_color}`,
                // '--dynamic-shadow': `inset 0 0 1.25em ${roomDetail?.active_speaker_highlight_color}`,
              }}
              key={participant.jid + "_" + participant?.type + "_partent"}>
              <VideoBlockContainer participant={participant} isVideoInactive={isVideoInactive} isBlocked={isBlocked} isAttendeeRecorder={isAttendeeRecorder} />
            </div>
          );
        })
      ) : (
        <span className="text-black stand-by">Please stand by until someone is unmuted.</span>
      )}
    </>
  );
}

export default GalleryView;
